/**
 * FoilDock Panama — theme.js
 * Vanilla JS, no frameworks, Shopify OS 2.0
 */

(function () {
  'use strict';

  // ============================================================
  // 1. SCROLL-BASED HEADER
  // ============================================================
  function initScrollHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var THRESHOLD = 60;

    function onScroll() {
      if (window.scrollY > THRESHOLD) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // run once on load
  }

  // ============================================================
  // 2. MOBILE MENU TOGGLE
  // ============================================================
  function initMobileMenu() {
    var hamburger = document.getElementById('NavHamburger');
    var menu      = document.getElementById('MobileMenu');
    var overlay   = document.getElementById('MobileMenuOverlay');
    var closeBtn  = document.getElementById('MobileMenuClose');

    if (!hamburger || !menu) return;

    var focusableSelectors = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    function openMenu() {
      menu.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';

      // Focus first focusable element
      var firstFocusable = menu.querySelector(focusableSelectors);
      if (firstFocusable) firstFocusable.focus();
    }

    function closeMenu() {
      menu.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      hamburger.focus();
    }

    function trapFocus(e) {
      if (!menu.classList.contains('is-open')) return;
      var focusables = Array.from(menu.querySelectorAll(focusableSelectors));
      var first = focusables[0];
      var last  = focusables[focusables.length - 1];

      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }
      if (e.key === 'Escape') {
        closeMenu();
      }
    }

    hamburger.addEventListener('click', function () {
      var isOpen = menu.classList.contains('is-open');
      if (isOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    if (overlay)  overlay.addEventListener('click', closeMenu);

    document.addEventListener('keydown', trapFocus);
  }

  // ============================================================
  // 3. MOBILE MENU SUBMENUS
  // ============================================================
  function initMobileSubmenus() {
    var triggers = document.querySelectorAll('.mobile-menu__link[data-submenu]');
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var targetId = this.dataset.submenu;
        var sub = document.getElementById(targetId);
        if (!sub) return;

        var isOpen = sub.classList.contains('is-open');
        // Close all
        document.querySelectorAll('.mobile-menu__sub.is-open').forEach(function (el) {
          el.classList.remove('is-open');
        });
        document.querySelectorAll('.mobile-menu__link[data-submenu]').forEach(function (el) {
          el.setAttribute('aria-expanded', 'false');
        });
        // Toggle this one
        if (!isOpen) {
          sub.classList.add('is-open');
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  // ============================================================
  // 4. NAVBAR DROPDOWN (click-to-toggle)
  // ============================================================
  function initNavDropdowns() {
    var triggers = document.querySelectorAll('.navbar__dropdown-trigger');

    function closeAll() {
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
        var menu = t.nextElementSibling;
        if (menu && menu.classList.contains('navbar__dropdown-menu')) {
          menu.classList.remove('is-open');
        }
      });
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var menu = this.nextElementSibling;
        var isOpen = menu && menu.classList.contains('is-open');

        closeAll();

        if (!isOpen && menu) {
          menu.classList.add('is-open');
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Close on outside click
    document.addEventListener('click', function () {
      closeAll();
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    // Close on focus outside
    document.addEventListener('focusin', function (e) {
      var inDropdown = e.target.closest('.navbar__dropdown');
      if (!inDropdown) closeAll();
    });
  }

  // ============================================================
  // 5. SCROLL REVEAL (IntersectionObserver)
  // ============================================================
  function initScrollReveal() {
    var elements = document.querySelectorAll('.reveal');
    if (!elements.length) return;

    // Respect prefers-reduced-motion: show everything instantly
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      elements.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    // Failsafe: reveal everything after 2.5 s in case IO never fires
    var failsafe = setTimeout(function () {
      elements.forEach(function (el) { el.classList.add('is-visible'); });
    }, 2500);

    if (!('IntersectionObserver' in window)) {
      clearTimeout(failsafe);
      elements.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        requestAnimationFrame(function () {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            var el    = entry.target;
            var index = parseInt(el.dataset.revealIndex || '0', 10);
            var delay = (index % 4) * 70; // stagger: 0 / 70 / 140 / 210 ms

            setTimeout(function () {
              el.classList.add('is-visible');
            }, delay);

            observer.unobserve(el);

            // Cancel failsafe once all elements are revealed
            var remaining = document.querySelectorAll('.reveal:not(.is-visible)');
            if (!remaining.length) clearTimeout(failsafe);
          });
        });
      },
      {
        threshold: 0.10,
        rootMargin: '0px 0px -40px 0px'
      }
    );

    // Assign sequential indices within each parent group, then observe
    elements.forEach(function (el, i) {
      if (!el.dataset.revealIndex) el.dataset.revealIndex = String(i);
      observer.observe(el);
    });
  }

  // ============================================================
  // 6. FAQ ACCORDION
  // ============================================================
  function initFAQ() {
    var items = document.querySelectorAll('.faq-item');
    items.forEach(function (item) {
      var question = item.querySelector('.faq-question');
      var answer   = item.querySelector('.faq-answer');
      if (!question || !answer) return;

      question.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        // Close all
        items.forEach(function (i) {
          i.classList.remove('is-open');
          var a = i.querySelector('.faq-answer');
          if (a) a.style.maxHeight = '0';
          var q = i.querySelector('.faq-question');
          if (q) q.setAttribute('aria-expanded', 'false');
        });

        // Toggle current
        if (!isOpen) {
          item.classList.add('is-open');
          answer.style.maxHeight = answer.scrollHeight + 'px';
          question.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  // ============================================================
  // 7. BACK TO TOP
  // ============================================================
  function initBackToTop() {
    var btn = document.getElementById('BackToTop');
    if (!btn) return;

    var THRESHOLD = 400;

    function updateVisibility() {
      if (window.scrollY > THRESHOLD) {
        btn.removeAttribute('hidden');
      } else {
        btn.setAttribute('hidden', '');
      }
    }

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    window.addEventListener('scroll', updateVisibility, { passive: true });
    updateVisibility();
  }

  // ============================================================
  // 8. HEADER SEARCH — ⌘K / CTRL+K SHORTCUT
  // ============================================================
  function initHeaderSearch() {
    var input = document.querySelector('.header-search__input');
    if (!input) return;

    document.addEventListener('keydown', function (e) {
      var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
      var modifier = isMac ? e.metaKey : e.ctrlKey;

      if (modifier && e.key === 'k') {
        e.preventDefault();
        input.focus();
        input.select();
      }

      if (e.key === 'Escape' && document.activeElement === input) {
        input.blur();
      }
    });
  }

  // ============================================================
  // 9. ANNOUNCEMENT BAR DISMISS
  // ============================================================
  function initAnnouncementBar() {
    var bar     = document.querySelector('.top-banner');
    var closeBtn = document.querySelector('.top-banner__close');
    if (!bar || !closeBtn) return;

    var STORAGE_KEY = 'fdp_banner_dismissed';

    // Hide if previously dismissed
    if (localStorage.getItem(STORAGE_KEY)) {
      bar.style.display = 'none';
      return;
    }

    closeBtn.addEventListener('click', function () {
      bar.style.display = 'none';
      try {
        localStorage.setItem(STORAGE_KEY, '1');
      } catch (e) {}
    });
  }

  // ============================================================
  // 10. SMOOTH ANCHOR SCROLL
  // ============================================================
  function initSmoothAnchor() {
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = this.getAttribute('href');
        if (!href || href === '#') return;

        var target = document.querySelector(href);
        if (!target) return;

        e.preventDefault();

        var headerH = document.querySelector('.site-header')
          ? document.querySelector('.site-header').offsetHeight
          : 0;

        var top = target.getBoundingClientRect().top + window.scrollY - headerH - 16;
        window.scrollTo({ top: top, behavior: 'smooth' });
        target.focus({ preventScroll: true });
      });
    });
  }

  // ============================================================
  // 11. HEADER SUBBAR — STICKY ON SCROLL
  // ============================================================
  function initSubbar() {
    var subbar = document.querySelector('.header-subbar');
    if (!subbar) return;
    // Subbar is part of sticky header; no additional JS needed.
    // Placeholder for future enhancements.
  }

  // ============================================================
  // 12. FORM VALIDATION HELPERS
  // ============================================================
  function initForms() {
    var forms = document.querySelectorAll('form[data-validate]');
    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var valid = true;
        var inputs = form.querySelectorAll('[required]');
        inputs.forEach(function (input) {
          if (!input.value.trim()) {
            valid = false;
            input.style.borderColor = '#ef4444';
            input.addEventListener('input', function () {
              this.style.borderColor = '';
            }, { once: true });
          }
        });
        if (!valid) {
          e.preventDefault();
          var first = form.querySelector('[required]:invalid, [required][value=""]');
          if (first) first.focus();
        }
      });
    });
  }

  // ============================================================
  // 13. LAZY LOAD IMAGES (native + polyfill)
  // ============================================================
  function initLazyLoad() {
    // Use native lazy loading where available
    document.querySelectorAll('img[data-src]').forEach(function (img) {
      img.setAttribute('loading', 'lazy');
      img.setAttribute('src', img.dataset.src);
    });
  }

  // ============================================================
  // 14. COUNTER ANIMATION (for stats)
  // ============================================================
  function animateCounter(el, end, duration) {
    var start = 0;
    var range = end - start;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
      el.textContent = Math.floor(eased * range + start).toLocaleString();
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  function initStatCounters() {
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      requestAnimationFrame(function () {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var raw = el.dataset.count;
          if (!raw) return;
          var num = parseInt(raw.replace(/\D/g, ''), 10);
          if (isNaN(num)) return;
          var suffix = raw.replace(/[\d,]/g, '');
          animateCounter(el, num, 1800);
          observer.unobserve(el);
        });
      });
    }, { threshold: 0.5 });

    document.querySelectorAll('[data-count]').forEach(function (el) {
      observer.observe(el);
    });
  }

  // ============================================================
  // INIT — DOMContentLoaded
  // ============================================================
  function init() {
    initScrollHeader();
    initMobileMenu();
    initMobileSubmenus();
    initNavDropdowns();
    initScrollReveal();
    initFAQ();
    initBackToTop();
    initHeaderSearch();
    initAnnouncementBar();
    initSmoothAnchor();
    initSubbar();
    initForms();
    initLazyLoad();
    initStatCounters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
